import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateUtilsService, DialogService, TranslationService } from '@sdbn/common';
import { TransportOptionLimitExceptionSchedule, TransportOptionLimitSchedule } from '../../../transport-options.model';
import { FormControl, FormGroup } from '@angular/forms';
import { DateTime } from 'luxon';

@Component({
    selector: 'app-transport-option-editor-limits-schedule',
    templateUrl: './transport-option-editor-limits-schedule.component.html',
    styleUrls: ['./transport-option-editor-limits-schedule.component.scss'],
    standalone: false
})
export class TransportOptionEditorLimitsScheduleComponent implements OnInit {

  formGroup = new FormGroup({
    dateFrom: new FormControl(),
    dateUntil: new FormControl(),
    limitMonday: new FormControl(),
    limitTuesday: new FormControl(),
    limitWednesday: new FormControl(),
    limitThursday: new FormControl(),
    limitFriday: new FormControl(),
    limitSaturday: new FormControl(),
    limitSunday: new FormControl()
  });

  @Input() schedule?: TransportOptionLimitSchedule;

  @Output() changed = new EventEmitter<TransportOptionLimitSchedule>();

  @Output() removeRequested = new EventEmitter<TransportOptionLimitSchedule>();

  constructor(
    private dialogService: DialogService,
    public translationService: TranslationService,
    private dateUtilsService: DateUtilsService
  ) {

  }

  ngOnInit(): void {
    this.initialize();
    this.formGroup.valueChanges.subscribe(value => {
      if (this.schedule) {

        this.schedule.dateFrom = this.dateUtilsService.convertDateToDatePartTimestamp(value.dateFrom);
        this.schedule.dateUntil = this.dateUtilsService.convertDateToDatePartTimestamp(value.dateUntil);
        this.schedule.limitMonday = this.formGroup.get('limitMonday')?.value;
        this.schedule.limitTuesday = this.formGroup.get('limitTuesday')?.value;
        this.schedule.limitWednesday = this.formGroup.get('limitWednesday')?.value;
        this.schedule.limitThursday = this.formGroup.get('limitThursday')?.value;
        this.schedule.limitFriday = this.formGroup.get('limitFriday')?.value;
        this.schedule.limitSaturday = this.formGroup.get('limitSaturday')?.value;
        this.schedule.limitSunday = this.formGroup.get('limitSunday')?.value;
        this.changed.emit(this.schedule);
      }
    });
  }

  private initialize() {
    if (this.schedule) {
      this.formGroup.patchValue({
        dateFrom: this.dateUtilsService.parseDateFromDatePartTimestamp(this.schedule.dateFrom!),
        dateUntil: this.dateUtilsService.parseDateFromDatePartTimestamp(this.schedule.dateUntil!),
        limitMonday: this.schedule.limitMonday,
        limitTuesday: this.schedule.limitTuesday,
        limitWednesday: this.schedule.limitWednesday,
        limitThursday: this.schedule.limitThursday,
        limitFriday: this.schedule.limitFriday,
        limitSaturday: this.schedule.limitSaturday,
        limitSunday: this.schedule.limitSunday
      });
    }
  }

  public addLimitExceptionSchedule(): void {
    if (this.schedule) {
      const newExceptionSchedule = new TransportOptionLimitSchedule();
      this.schedule.limitExceptionSchedules.push(newExceptionSchedule);
    }
  }

  public removeExceptionSchedule(exceptionSchedule: TransportOptionLimitExceptionSchedule) {
    if (this.schedule) {
      this.dialogService.showConfirm(
        'tmc-yard.control.ui.transport-option-administration.confirm-remove-limit-exception-schedule-title',
        'tmc-yard.control.ui.transport-option-administration.confirm-remove-limit-exception-schedule-message'
      ).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          const index = this.schedule!.limitExceptionSchedules.indexOf(exceptionSchedule, 0);
          if (index > -1) {
            this.schedule!.limitExceptionSchedules.splice(index, 1);
          }
        }
      });
    }
  }

  public removeLimitSchedule(): void {
    if (this.schedule) {
      this.removeRequested.emit(this.schedule);
    }
  }

}
